export default "__VITE_ASSET__CXlOsO0N__"